<template>
  <div>
    <div class="oss-title">
      <div>{{ $t("RAM.ALI.Oss.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:ali:oss:update']"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:ali:oss:export']"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="redis-top">
      <oss-search ref="child"></oss-search>
    </div>
    <table-oss-resource></table-oss-resource>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import OssSearch from "./OssSearch";
import TableOssResource from "./TableOssResource";
import Export from "../Export";

export default {
  name: "Oss",
  components: {
    OssSearch,
    TableOssResource,
    Export
  },
  data() {
    return {
      loading: false,
      modal_loading: false
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.child.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 5,
          accountType: 1
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      var exportDTO = {
        name: this.$refs.child.accountName,
        accountType: 1,
        companyId: this.$refs.child.companyId
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement.exportAliOss(exportDTO).then(res => {
        let fileName = "Oss.xls";
        let blob = new Blob([res.data], { type: "application/x-xls" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.success(this.$t('common.exportSuccess'));
      });
    }
  }
};
</script>

<style scoped>
.oss-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.oss-title > div:nth-child(1) {
  float: left;
}
.oss-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.oss-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/oss/Oss.vue